module.exports = __webpack_public_path__ + "img/Device-Attendance.48669412.png";